import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { NavigationService } from '@modules/core/navigation/navigation.service';
import { AppConfigService } from '@services/app-config.service';

import { GemAuthService } from './gem-auth.service';

@Injectable()
export class GemAuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly gemAuthService: GemAuthService,
    private readonly appConfigService: AppConfigService,
    private readonly navigationService: NavigationService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(this.appConfigService.environment.GEM_URL)) {
      return next.handle(request);
    }

    return this.gemAuthService.getToken().pipe(
      switchMap((token: string) =>
        next.handle(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          })
        )
      ),
      catchError(error => {
        if (
          error instanceof HttpErrorResponse &&
          [HttpStatusCode.Unauthorized, HttpStatusCode.Forbidden].includes(error.status)
        ) {
          this.navigationService.navigateToUnauthorized();
        }

        return throwError(() => error);
      })
    );
  }
}
